import React from "react";
import { motion } from "framer-motion";

const ReportAnimatedTitle = ({ title }) => {
    const len = title?.length ?? 0;

    return (
        <motion.h1
            initial={{ opacity: 0, y: 8, filter: "blur(6px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className="text-[18px] sm:text-[20px] font-bold tracking-tight leading-tight
                       text-gray-900 dark:text-white"
        >
            <motion.span
                className="inline-block overflow-hidden whitespace-nowrap align-bottom"
                initial={{ width: "0ch" }}
                animate={{ width: ["0ch", `${len}ch`, `${len}ch`, "0ch"] }}
                transition={{
                    duration: 4.8,
                    times: [0, 0.22, 0.9, 1],
                    ease: ["linear", "linear", "easeInOut"],
                    repeat: Infinity,
                }}
            >
                {title}
            </motion.span>
        </motion.h1>
    );
};

export default ReportAnimatedTitle;
